module.exports = __webpack_public_path__ + "resources/rank_left.7bc89ab1947cc051.png";


//////////////////
// WEBPACK FOOTER
// ../src/ui/label/img/rank_left.png
// module id = 537
// module chunks = 0 1 2 3